<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { ImageSize } from './Utils';
    import { query } from '$lib/apollo/SvelteApollo.js';
    import { LinkMetaDataDocument, LinkMetaDataFragmentDoc } from '$gql/graphql.js';
    import { useFragment } from '$gql/fragment-masking.js';
    import LinkMetaData from './LinkMetaData.svelte';

    export let url: string;
    export let linkClass: string = '';
    export let maxSize: ImageSize = null;

    export let show: (id: number) => boolean;

    const dispatch = createEventDispatcher<{
        load: { url: string; id: number };
        remove: number;
    }>();

    const { result, setVariables } = query(LinkMetaDataDocument, {
        variables: { url },
    });

    $: setVariables({ url });
    $: linkMetaData = useFragment(LinkMetaDataFragmentDoc, $result.data?.linkMetaData);
    $: id = linkMetaData?.id;
    $: if (id != null) dispatch('load', { url, id });
</script>

{#if linkMetaData != null && show(linkMetaData.id)}
    <LinkMetaData
        {linkMetaData}
        {linkClass}
        {maxSize}
        on:buttonclick={() => {
            dispatch('remove', id ?? 0);
        }}
        withButton
    />
{/if}
